





















import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "ApprovalList",
  components: {},
  props: {
    id: {
      default: "default",
      type: String,
    },
    approvals: Array,
    isOptional: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      checklist: [],
      isValidated: false,
    };
  },
  created() {},
  methods: {
    getDisplayHtml(text: string): String {
      var html: string = "";

      if (text) {
        html = this.fillInHtml(text);
      }

      return html;
    },

    getSanitizedContent(text: string) {
      return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    },

    fillInHtml(text: string) {
      var html: string;

      var sanitizedContent = this.getSanitizedContent(text);

      html = sanitizedContent.replace(/\[\[(.*?)\]\]/g, (replace, param) => {
        param = param.trim();
        var tag = "";

        if (param.includes("{")) {
          var json = JSON.parse(param);
          for (let i in json) {
            tag += "<" + i;
            for (let k in json[i]) {
              tag += " " + k;
              tag += '="' + json[i][k];
              tag += '"';
            }
            tag += ">";
          }
        } else {
          tag = "<" + param + ">";
        }

        return tag;
      });

      return html;
    },

    validate() {
      this.isValidated = true;
      var check = true;

      if (!this.isOptional) {
        if (this.checklist.length < this.approvals.length) {
          check = false;
        } else {
          if (this.checklist.includes(false as never)) {
            check = false;
          }
        }
      }

      return check;
    },
  },
  watch: {},
  computed: {},
});
